import React, { useEffect, useRef } from "react";
import Spinner from "../../component/spinner/Spinner";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Global_Data } from "../../globalData/GlobalData";
import { serverAddress } from "../../config";
import { clearAuthentication, getAccessToken } from "../../auth/authClient";

function Logout() {
  const navigate = useNavigate();
  const { token, setToken, setUserData, setsideBarStyle } = Global_Data();
  const logoutStartedRef = useRef(false);

  useEffect(() => {
    if (logoutStartedRef.current) {
      return;
    }

    logoutStartedRef.current = true;

    const accessToken = token || getAccessToken();

    // Server-side token invalidation is best effort. A rejected or unavailable
    // logout endpoint must not prevent the local session from being closed.
    if (accessToken && serverAddress) {
      axios
        .post(
          `${serverAddress}/user/logout`,
          {},
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          }
        )
        .catch(err => console.warn("Server logout request failed", err));
    }

    clearAuthentication("LOGOUT");
    localStorage.clear();
    setToken(null);
    setUserData(undefined);
    setsideBarStyle("");
    navigate("/login", { replace: true });
  }, [navigate, setToken, setUserData, setsideBarStyle, token]);

  return (
    <>
      <div
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div>
          <Spinner />
        </div>
      </div>
    </>
  );
}

export default Logout;
